import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { Button } from 'reactstrap';
import { toast } from 'react-toastify';
import { useForm } from 'react-hook-form';
import ContactForm from './ContactForm';
import FilesForm from './FilesForm';
import { desiredPortTimeZoneOptions } from './constant';

export default function OrderForm({ submit, intialValue, onBack, id }) {
  const form = useForm({ defaultValues: intialValue });
  const {
    control,
    register,
    handleSubmit,
    getValues,
    setValue,
    formState: { errors, submitCount, isSubmitted },
  } = form;
  const [activeCheck, setActiveCheck] = useState(false);

  useEffect(() => {
    if (isSubmitted && Object.keys(errors)?.length) {
      console.log(errors, getValues());
      toast.error('Please fix error and submit again');
    }
  }, [submitCount]);

  return (
    <form onSubmit={handleSubmit(submit)} className="shadow-none row no-gutters">
      <label className="p-3">
        <span className="font-weight-bolder text-left d-block mb-2">PON*</span>
        <input
          className="form-control"
          defaultValue={getValues().customerOrderReference}
          {...register('customerOrderReference', { required: 'This is required' })}
          type="text"
        />
        {errors?.customerOrderReference && (
          <div className="text-danger font-weight-bold">
            {errors?.customerOrderReference?.message}
          </div>
        )}
      </label>
      <label className="p-3">
        <span className="font-weight-bolder text-left d-block mb-2">Reseller Name</span>
        <input
          className="form-control"
          defaultValue={getValues().resellerName}
          {...register('resellerName', {maxLength: 25,})}
          type="text"
          maxLength={25}
        />
        {errors?.resellerName?.message ? (
          <div className="text-danger font-weight-bold">{errors?.resellerName?.message}</div>
        ) : (
          (errors?.resellerName?.type === 'maxLength') && (
            <div className="text-danger font-weight-bold">The length of the reseller name should be no more than 25 characters.</div>
          )
        )}
      </label>
      <div className="h3 font-weight-bold w-100 col-12 px-3 pt-3">Desired Port Time</div>

      <label className="p-3 custom-control custom-checkbox">
        <span className="font-weight-bolder text-left d-block mb-2">On Demand Activation</span>
        <input
          {...register('onDemandActivation')}
          defaultChecked={getValues().onDemandActivation === 'Y'}
          type="checkbox"
          onChange={e => {
            const { target } = e;
            setActiveCheck(target.checked);
            setValue(`onDemandActivation`, target.checked);
          }}
          className="custom-control-input ml-0"
        />
        <span className="custom-control-label ml-4">Active</span>
      </label>

      <label className="p-3">
        <span className="font-weight-bolder text-left d-block mb-2">Desired Due Date*</span>
        <input
          defaultValue={getValues().desiredDueDate}
          className="form-control"
          {...register('desiredDueDate', {
            required: 'This is required',
            // validate: {
            //   past: val => {
            //     const value = moment(val);
            //     return (
            //       value.diff(moment().format('YYYY-MM-DD'), 'day') >= 0 ||
            //       'Desired Date Cannot Be in Past'
            //     );
            //   },
            //   twodays: val => {
            //     const value = moment(val);
            //     const valid =
            //       value.diff(moment().format('YYYY-MM-DD'), 'day') > 2 ||
            //       intialValue.desiredDueDate === value.format('YYYY-MM-DD');

            //     return (
            //       valid ||
            //       'Desired date cannot be changed within 48 hours of target date. Add a note for new date below'
            //     );
            //   },
            // },
          })}
          type="date"
        />
        {errors?.desiredDueDate && (
          <div className="text-danger font-weight-bold">{errors?.desiredDueDate?.message}</div>
        )}
      </label>

      <label className="p-3">
        <span className="font-weight-bolder text-left d-block mb-2">
          Desired Port Time{activeCheck ? null : '*'}
        </span>
        <input
          type="time"
          className="form-control"
          defaultValue={getValues().desiredPortTime}
          {...register('desiredPortTime', { required: activeCheck ? false : 'This is required' })}
        />
        {errors?.desiredPortTime && (
          <div className="text-danger font-weight-bold">{errors?.desiredPortTime?.message}</div>
        )}
      </label>

      <label className="p-3">
        <span className="font-weight-bolder text-left d-block mb-2">
          Desired Time Zone{activeCheck ? null : '*'}
        </span>
        <select
          className="form-control"
          defaultValue={getValues().desiredPortTimeZone}
          {...register('desiredPortTimeZone', {
            required: activeCheck ? false : 'This is required',
          })}
        >
          <option value="">Please Select</option>
          {desiredPortTimeZoneOptions.map(({ value, text, disabled }) => (
            <option disabled={disabled} key={value} value={value}>
              {text}
            </option>
          ))}
        </select>
        {errors?.desiredPortTimeZone && (
          <div className="text-danger font-weight-bold">{errors?.desiredPortTimeZone?.message}</div>
        )}
      </label>

      <div className="h3 font-weight-bold w-100 col-12 px-3 pt-3">Order Contact</div>

      <ContactForm arrayName="contact" form={form} />

      <label className="p-3 w-100 col-12">
        <span className="h3 font-weight-bold d-inline-block">Notes{id && '*'}</span>
        <textarea
          defaultValue={getValues().tnNote}
          {...register('tnNote', { required: id && 'This is required' })}
          className="form-control w-auto"
          rows="10"
          style={{ minWidth: '500px' }}
        />
        {errors?.tnNote && (
          <div className="text-danger font-weight-bold">{errors?.tnNote?.message}</div>
        )}
      </label>

      <div className="h3 font-weight-bold w-100 col-12 px-3 pt-3">Attachments</div>

      <div>
        <div className="p-3">
          <div className="text-left d-block mb-2 col-12 p-0 w-100">Document Title</div>
          <FilesForm
            accept=".docx,.txt,.xlsx,.pdf,.log,.pcap,.zip,.jpg,.jpeg,.ping,.gif,.pptx,.png"
            arrayName="files"
            form={form}
          />
        </div>
      </div>
      <div className="text-right w-100">
        {!id && (
          <Button color="primary" type="button" onClick={onBack} className="mr-2">
            Previous
          </Button>
        )}
        <Button type="submit" className="mr-2" color="primary">
          Submit
        </Button>
      </div>
    </form>
  );
}
